export const getColorByValue = (value: number) => {
  // Define your color mapping logic here based on the `value` parameter
  // Return the corresponding color for each value
  if (value >= 0 && value <= 20) {
    return '#005ca7';
  } else if (value > 20 && value <= 40) {
    return '#06d66e';
  } else if (value > 40 && value <= 60) {
    return '#f8dc00';
  } else if (value > 60 && value <= 80) {
    return '#ce8208';
  } else if (value > 80) {
    return '#ef476f';
  }

  // Default color if none of the conditions are met
  return 'black';
};
